import type { AuthServiceInterface, GetAuthTokenModel } from '@acme/domains';
import { UserStatusEnum, getAuthSecret, getAuthToken } from '@acme/domains';
import { DigitalSignatureLogin } from '@acme/features';
import { useAuth } from '../lib';

const authService: AuthServiceInterface = {
  getAuthSecret,
  getAuthToken: getAuthToken as GetAuthTokenModel,
};

const EcpLoginPage = () => {
  const { auth, loading, error, remainingCountOfPasswordAttempts } = useAuth({
    authService,
    onSuccessRedirect: (userStatus?: UserStatusEnum) => {
      if (userStatus === UserStatusEnum.ExpectsChanges) {
        window.location.href = '/profile';
      } else {
        window.location.href = '/dashboard';
      }
    },
  });

  return (
    <DigitalSignatureLogin
      onAuth={auth}
      loading={loading}
      error={error}
      remainingCountOfPasswordAttempts={remainingCountOfPasswordAttempts}
      supportsRoleSelection={true}
    />
  );
};

export { EcpLoginPage };
